import { CompanyOffice } from '@reaction-club-types/core'
import types from './types'

export default {
  set: (company: CompanyOffice) => ({ type: types.SET, payload: company }),
  delete: (office_id: string) => ({ type: types.DELETE, payload: office_id }),
}
